export default __webpack_public_path__ + "static/media/1705.6504c9c2.png";